<template>
  <figure class="overflow-hidden rounded-2xl border border-navy-100 bg-white shadow-card">
    <div class="relative select-none">
      <img :src="after" alt="After cleaning" class="block h-72 w-full object-cover sm:h-[26rem]" />

      <img
        :src="before"
        alt="Before cleaning"
        class="absolute inset-0 h-full w-full object-cover"
        :style="{ clipPath: `inset(0 ${100 - position}% 0 0)` }"
      />

      <span class="pointer-events-none absolute left-4 top-4 rounded-full bg-navy-950/75 px-3 py-1 text-[0.7rem] font-bold uppercase tracking-wider text-white backdrop-blur-sm">
        Before
      </span>
      <span class="pointer-events-none absolute right-4 top-4 rounded-full bg-sky-300/90 px-3 py-1 text-[0.7rem] font-bold uppercase tracking-wider text-navy-950 backdrop-blur-sm">
        After
      </span>

      <!-- divider + handle -->
      <div class="pointer-events-none absolute inset-y-0 w-0.5 bg-white shadow-[0_0_0_1px_rgba(12,27,56,.15)]" :style="{ left: `${position}%` }">
        <span class="absolute top-1/2 left-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center gap-0.5 rounded-full bg-white text-navy-900 shadow-lift">
          <i class="fas fa-chevron-left text-[0.6rem]"></i>
          <i class="fas fa-chevron-right text-[0.6rem]"></i>
        </span>
      </div>

      <input
        v-model.number="position"
        type="range"
        min="0"
        max="100"
        step="0.1"
        aria-label="Reveal the before and after photo"
        class="absolute inset-0 h-full w-full cursor-ew-resize appearance-none bg-transparent opacity-0"
      />
    </div>

    <figcaption class="flex items-center justify-center gap-2 px-5 py-3.5 text-xs font-semibold uppercase tracking-[0.18em] text-navy-500">
      <i class="fas fa-left-right text-[0.7rem] text-sky-400"></i>
      Drag to compare
    </figcaption>
  </figure>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
  before: String,
  after: String
})

const position = ref(50)
</script>
